module.exports = __webpack_public_path__ + "fonts/LeagueGothic-Regular.cad4b359.otf";